export const ROOT = '/:deviceId' as const

export const SUPPORTED_LANGUAGES = ['ja', 'en'] as const

export const Language = {
  Japanese: 'ja',
  English: 'en',
} as const

export const Requirement = {
  CheckIn: 'checkIn',
  CheckOut: 'checkOut',
  Other: 'other',
} as const

export type LanguageType = (typeof Language)[keyof typeof Language]
export type RequirementType = (typeof Requirement)[keyof typeof Requirement]

export const PATH = {
  root: ROOT,
  requirement: '/:deviceId/requirement',
  selectLanguage: '/:deviceId/select-language',
  dial: '/:deviceId/dial',
  alexConnect: '/:deviceId/alex-connect',
  about: '/:deviceId/about',
  home: '/:deviceId/home',
  finish: '/:deviceId/finish',
  setting: '/:deviceId/setting',
  callback: '/:deviceId/callback',
  cancel: '/:deviceId/cancel',
  maintenance: '/:deviceId/maintenance',
  sytemMaintenance: '/:deviceId/system-maintenance',
}

export const TIMEOUT_MILLISECONDS = 1000 * 60 * 1 // 1 minute

// TODO: Retrieve from API
export const SKIP_REQUIREMENT_DEVICES = [
  // RONT devices do not require check-in via calls
  '42d9a176-67ed-4722-9bdc-7f300ce97c2d', // GRAND HOSTEL LDK Tokyo Nishikasai1
  'd0d766f1-0cef-44d6-92e7-3a1ff947c9a4', // GRAND HOSTEL LDK Tokyo Nishikasai2
  '650cea61-9c0e-41aa-bcac-8c09db15e0be', // GRAND HOSTEL LDK Tokyo Nishikasai3
  '48e79929-7e76-46c7-a09e-b58501783031', // GRAND HOSTEL LDK Tokyo Nishikasai4
  '5e0a30fe-24ba-4898-af47-f4df061466b2', // GRAND HOSTEL LDK Tokyo Nishikasai5
  '10bcc507-df76-41b1-a484-8614b67db692', // GRAND HOSTEL LDK Tokyo Nishikasai6
  '1c1ab455-b777-42df-a6a9-18f716b2b133', // GRAND HOSTEL LDK Tokyo Nishikasai7
  '23326127-a233-4a40-a5d8-f29058cd9c86', // GRAND HOSTEL LDK Tokyo Nishikasai8
  '68a34348-d52e-4390-a1d2-4939e232ac50', // GRAND HOSTEL LDK Tokyo Nishikasai9
]

export const ERROR_TYPE = {
  OFFLINE: 'offline',
  FAILED_TO_DIALED: 'failed_to_dial',
  FAILED_TO_LAUNCH_ALEX: 'failed_to_launch_alex',
  FAILED_TO_FETCH_DEVICE: 'failed_to_fetch_device',
} as const

export type ErrorType = (typeof ERROR_TYPE)[keyof typeof ERROR_TYPE]
